import {
  decrypt,
  sha256,
  convertStrToUint8Array,
  importKey,
} from '../common/function';

function makeImageUrl(decryptedIamge: ArrayBuffer) {
  const arrayBufferView = new Uint8Array(decryptedIamge);
  const blob = new Blob([arrayBufferView]);
  return window.URL.createObjectURL(blob);
}

export async function descriptKeys({
  userId,
  episodeId,
  timestamp,
  nonce,
  aid,
  zid,
}: {
  userId?: string;
  episodeId: number;
  timestamp: string;
  nonce: string;
  aid: string;
  zid: string;
}) {
  if (!window.crypto || !window.crypto.subtle) {
    // @ts-ignore
    await import('webcrypto-shim');
  }

  const keyStr = `${userId ?? episodeId}${episodeId}${timestamp}`;
  const ivStr = `${nonce}${timestamp}`;
  const kek = await sha256(keyStr);
  const iv = (await sha256(ivStr)).slice(0, 16);
  const encryptedCek = convertStrToUint8Array(atob(aid));
  const encryptedIv = convertStrToUint8Array(atob(zid));
  const cryptoKey = await importKey(kek);

  if (cryptoKey) {
    const cek = await decrypt({
      data: encryptedCek,
      cryptoKey,
      iv,
    });

    const civ = await decrypt({
      data: encryptedIv,
      cryptoKey,
      iv,
    });

    return {key: cek, iv: civ};
  }
}

export async function decryptImage({
  image,
  key,
  iv,
}: {
  image: ArrayBuffer;
  key: ArrayBuffer;
  iv: ArrayBuffer;
}): Promise<string | undefined> {
  const cryptoKey = await importKey(key);
  if (!cryptoKey) return;

  const decryptedIamge = await decrypt({data: image, cryptoKey, iv});
  if (!decryptedIamge) return;

  return makeImageUrl(decryptedIamge);
}
